// extracted by mini-css-extract-plugin
export default {"form_control":"Input_form_control__ua87F"};